<template>
  <div class='date-group' ref='dategroup'>
      <slot v-bind:dateGroup="true"/>
  </div>
</template>

<script>
import themeSetupMixin from '@/mixins/theme';

export default {
  inheritAttrs: false,
  mixins: [themeSetupMixin],
  name: 'DateGroup',
};
</script>

<style lang='scss'>

.date-group {
    position: relative;
    .form-control__suffix, .form-control__prefix {
        font-size: 12px;
        line-height: 20px;
        img {
            margin-top:7px;
        }
    }
    .form-group {
        margin:5px 0;
    }
    .date-picker:nth-child(1) {
        .form-control {
            padding-left:50px;
        }
    }
    @media (min-width: 640px){
        display: inline-flex;
        align-items: center;
        width:100%;
        position: relative;
        border-width: 1px;
        border-style: solid;
        border: 1px solid var(--primary-30);
        border-radius: 4px;
        width: 100%;
        font-size: 16px;
        transition: all .2s ease-in-out;
        .form-group {
            margin:0;
            padding:0;
        }
        .date-picker {
            position: none;
            .calendar{
                position: none;
            }
            .form-group {
                position: none;
            }
        }
        .date-picker:nth-child(1) {
            .form-control {
                padding-right:0;
            }
            .form-control__suffix {
                display:none;
            }
        }
        .date-picker:nth-child(2) {
            .form-control__prefix{
                padding-left:5px;
            }
            .form-control {
                padding-left:26px;
            }
        }
        .form-control {
            border:none;
        }
        &:focus-within {
            outline: none;
            border-color: var(--brand-main);
        }
    }
}
</style>
